import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toInAppPath } from "../launchHandler";

function PWA() {
  const navigate = useNavigate();

  useEffect(() => {
    const path = toInAppPath(window.location.href);
    if (path) navigate(path);
  }, [navigate]);

  return null;
}

export default PWA;
